import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LOSJsonPath } from '../models/los-field-path';
import { protectedResources } from '../auth-config';
import { ToastService } from './toast.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class FieldPathService {
  private baseUrl: string = protectedResources.LOSTalkerAPI.endpoint;
  private actionUrl = '';
  private Url = '';
  private headers = new HttpHeaders();

  private errorHandler(error: HttpErrorResponse, ts: ToastService): Observable<any> {
    ts.toastCreate('An HTTP transport error occured: ' + error.url + ' ' + error.status, 'Warning', {
      keepAfterRouteChange: true,
    });

    if (environment.enableDebuggingTools) {
      console.error('An HTTP transport error occured: ' + error.error);
    }

    return throwError(() => error);
  }

  constructor(private http: HttpClient, private toastService: ToastService) { }

  getAllFieldPaths(): Observable<LOSJsonPath[]> {
    this.actionUrl = 'LOSJsonPaths/'; 
    this.Url = this.baseUrl.concat(this.actionUrl);

    return this.http
      .get<LOSJsonPath[]>(this.Url)
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  getLOSJsonPathByFieldId(fieldId: string): Observable<LOSJsonPath> {
    this.actionUrl = 'LOSJsonPath';
    this.Url = this.baseUrl.concat(this.actionUrl, fieldId);

    return this.http
      .get<LOSJsonPath>(this.Url)
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  deleteLOSJsonPath(field: LOSJsonPath): Observable<any> {
    this.actionUrl = 'LOSJsonPath/';
    this.Url = this.baseUrl.concat(this.actionUrl, field.losJsonPathId);
    this.headers.append('Content-Type', 'application/json');

    return this.http
      .delete<any>(this.Url, { headers: this.headers })
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  insertLOSJsonPath(field: LOSJsonPath): Observable<any> {
    this.actionUrl = 'LOSJsonPath/';
    this.Url = this.baseUrl.concat(this.actionUrl);
    this.headers.append('Content-Type', 'application/json');

    return this.http
      .post(this.Url, field, { headers: this.headers })
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  updateLOSJsonPath(field: LOSJsonPath): Observable<any> {
    this.actionUrl = 'LOSJsonPath/';
    this.Url = this.baseUrl.concat(this.actionUrl);

    return this.http
      .put(this.Url, field, { headers: this.headers })
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

}
